import { api } from "./client";
import type { LeaderboardResponse, PlayerProfile } from "../types";

export const leaderboardApi = {
  getLeaderboard: (limit = 50, offset = 0) =>
    api.get<LeaderboardResponse>(`/leaderboard?limit=${limit}&offset=${offset}`),

  getPlayerProfile: (userId: number) =>
    api.get<PlayerProfile>(`/leaderboard/players/${userId}`),
};
